export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (a420fd6d)";
export var GIT_SHA = "a420fd6d";
export var THEME = "open-source-visual-refresh";
export var SYSTEM = "core";
export var ALWAYS_VISUAL_REFRESH = true;
export var INCLUDE_ONE_THEME = false;